<template>
  <v-app>
    <v-main>
      <PluginAlert />
      <PluginConfirmDialog />
      <PluginLoading />
      <MainToolbar />
      <router-view></router-view>
      <DocumentDialog />
      <SignInDialog />
      <ForgotPasswordDialog />
      <ConfirmForgotPasswordDialog />
      <NewPasswordDialog />
      <PrimarySignUpDialog v-if="useCommonSignUp" />
      <SignUpDialog v-else />
      <ConfirmSignupDialog />
      <!-- <Form02ReminderDialog v-if="isHomePage" ref="form02ReminderDialog" />
      <Grade10ExamScoreReminderDialog v-if="isHomePage" ref="grade10ExamScoreReminderDialog" /> -->
      <!-- <InterviewRegistrationDialog v-if="isHomePage && isAuthenticated" /> -->
    </v-main>
  </v-app>
</template>

<script>
import MainToolbar from '@/components/layout/MainToolbar.vue'
import SignInDialog from '@/views/auth/SignInDialog.vue'
import ForgotPasswordDialog from '@/views/auth/ForgotPasswordDialog.vue'
import ConfirmForgotPasswordDialog from '@/views/auth/ConfirmForgotPasswordDialog.vue'
import NewPasswordDialog from '@/views/auth/NewPasswordDialog.vue'
import SignUpDialog from '@/views/auth/SignUpDialog.vue'
import PrimarySignUpDialog from '@/views/auth/PrimarySignUpDialog.vue'
import ConfirmSignupDialog from '@/views/auth/ConfirmSignupDialog.vue'
import DocumentDialog from '@/views/document/DocumentDialog.vue'
import PluginConfirmDialog from '@/components/plugin/PluginConfirmDialog'
import PluginAlert from '@/components/plugin/PluginAlert'
import PluginLoading from '@/components/plugin/PluginLoading'
// import Form02ReminderDialog from './Form02ReminderDialog.vue'
// import Grade10ExamScoreReminderDialog from './Grade10ExamScoreReminderDialog.vue'
// import InterviewRegistrationDialog from '@/modules/interview/parent/InterviewRegistrationDialog.vue'
import {mapActions, mapGetters} from 'vuex'
import {get} from 'lodash'
export default {
  name: 'App',
  components: {
    MainToolbar,
    SignInDialog,
    ForgotPasswordDialog,
    ConfirmForgotPasswordDialog,
    NewPasswordDialog,
    SignUpDialog,
    PrimarySignUpDialog,
    ConfirmSignupDialog,
    DocumentDialog,
    PluginAlert,
    PluginConfirmDialog,
    PluginLoading,
    // Form02ReminderDialog,
    // Grade10ExamScoreReminderDialog,
    // InterviewRegistrationDialog,
  },
  data() {
    return {
      isDevelopmentBuild: true,
      version: '0.1',
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'user']),
    ...mapGetters('layout', ['selectedGrade']),
    ...mapGetters('site', ['siteGrade']),
    // Mọi khối dùng chung form đăng ký (SĐT phụ huynh); site chưa xác định khối (localhost) giữ cách chọn cũ
    useCommonSignUp() {
      return Boolean(this.siteGrade) || this.selectedGrade === 'primary'
    },
    isHomePage() {
      return this.$route.path === '/'
    },
  },
  created() {
    this.version = process.env.VUE_APP_API_VERSION
    this.isDevelopmentBuild = process.env.NODE_ENV === 'development'
  },
  mounted() {
    this.openReminderDialogs()
  },
  watch: {
    '$route.path'() {
      this.openReminderDialogs()
    },
    isAuthenticated() {
      this.openReminderDialogs()
    },
  },
  methods: {
    ...mapActions('cv', ['fetchCV']),
    async openReminderDialogs() {
      if (!this.isHomePage || !this.isAuthenticated || !get(this.user, 'id')) return

      const document = await this.fetchCV({parent: this.user.id})
      const showGrade10ExamScoreReminder = this.canShowGrade10ExamScoreReminder(document)
      if (!showGrade10ExamScoreReminder) return

      this.$nextTick(() => {
        if (showGrade10ExamScoreReminder && this.$refs.grade10ExamScoreReminderDialog) {
          this.$refs.grade10ExamScoreReminderDialog.openDialog()
        }
      })
    },
    
    canShowGrade10ExamScoreReminder(document) {
      if (!document || document.type !== 'Khối 10') return false
      
      // Trường hợp đã nhập học hoặc chưa có hồ sơ
      const hasEnrollPayment = get(document, 'enrollPayment', '')
      if (hasEnrollPayment || document?.step <= 3) return false
      
      // Trường họp đạt tuyển thẳng
      const admissionResult = get(document, 'admissionResult', [])
      const hasPassedDirectAdmission = admissionResult.some(item => {
        const isDirectAdmission = item?.checkpoint === 'Xét tuyển thẳng 25/04/2026'
        return (
          isDirectAdmission &&
          [item.baseAdmitted, item.engAdmitted, item.mathAdmitted, item.math2Admitted].includes('pass')
        )
      })
      if (hasPassedDirectAdmission) return false

      // Trường hợp đã điền
      if(document?.publicExamEng || document.publicExamLit || document?.publicExamMath) return false
      return true
    },
  },
}
</script>
<style>
.container.fill-height > .row {
  flex: 1 1 100%;
  max-width: calc(100%) !important;
}

.v-card--link:focus:before {
  opacity: 0 !important;
}
#notice {
  position: absolute;
  bottom: 12px;
  left: 12px;
}
</style>
